import { render } from "./MatchListHeaderOption.vue?vue&type=template&id=47fb7ba0&scoped=true"
import script from "./MatchListHeaderOption.vue?vue&type=script&lang=js"
export * from "./MatchListHeaderOption.vue?vue&type=script&lang=js"

import "./MatchListHeaderOption.vue?vue&type=style&index=0&id=47fb7ba0&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47fb7ba0"]])

export default __exports__